import { render, staticRenderFns } from "./autofunding.vue?vue&type=template&id=5c5c27e2&"
import script from "./autofunding.vue?vue&type=script&lang=js&"
export * from "./autofunding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports